// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearchBar_searchContainer__7-gfJ","inputContainer":"SearchBar_inputContainer__lxE00","input":"SearchBar_input__acicz","magni":"SearchBar_magni__z3BXp"};